import type { ReactNode } from 'react'
import React from 'react'

import * as S from './styled'

type Props = {
  children: ReactNode
}

export const DashboardSectionItem = ({ children }: Props) => {
  return <S.SectionItem>{children}</S.SectionItem>
}
